import { getFiltroUsuarios } from './filtroUsuarios';

const originalFetch = window.fetch.bind(window);

// Filtros recordados de Prospectación (sessionStorage, clave + id de usuario).
// Se borran junto con la sesión: logout, 401 y cierre por inactividad.
export const CLAVE_FILTROS_PROSPECTACION = 'prospectacion_filtros_';
const borrarFiltrosGuardados = () => {
  try {
    Object.keys(sessionStorage)
      .filter(k => k.startsWith(CLAVE_FILTROS_PROSPECTACION))
      .forEach(k => sessionStorage.removeItem(k));
  } catch { /* sin sessionStorage: no hay nada que borrar */ }
};

// Identificador aleatorio de este navegador (sesión única por usuario, ver
// backend/auth/sesiones.js): si el login llega desde el mismo navegador que ya
// tiene la sesión, la reemplaza en vez de bloquearlo. NO se borra al cerrar
// sesión; las pestañas lo comparten y una ventana de incógnito tiene otro.
const CLAVE_DISPOSITIVO = 'dispositivo_id';
const getDispositivoId = () => {
  try {
    let id = localStorage.getItem(CLAVE_DISPOSITIVO);
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(CLAVE_DISPOSITIVO, id);
    }
    return id;
  } catch {
    return null; // sin localStorage: el servidor lo trata como navegador desconocido
  }
};

const esLlamadaApi = (input) => {
  const url = typeof input === 'string' ? input : input.url;
  return url.includes('/api/') || url.startsWith('/api');
};

window.fetch = async (input, init = {}) => {
  if (esLlamadaApi(input)) {
    const token = localStorage.getItem('token');
    // Filtro de usuarios del Administrador Plus (ver filtroUsuarios.js); vacío = Todos.
    const filtroUsuarios = getFiltroUsuarios();
    const dispositivoId = getDispositivoId();
    init = {
      ...init,
      headers: {
        ...(init.headers || {}),
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(filtroUsuarios.length ? { 'X-Filtro-Usuarios': filtroUsuarios.join(',') } : {}),
        ...(dispositivoId ? { 'X-Dispositivo-Id': dispositivoId } : {}),
      },
    };
  }
  const response = await originalFetch(input, init);
  if (response.status === 401 && esLlamadaApi(input)) {
    localStorage.removeItem('token');
    localStorage.removeItem('usuarioActual');
    borrarFiltrosGuardados();
    window.location.reload();
  }
  return response;
};

export const setSesion = (token, usuario) => {
  localStorage.setItem('token', token);
  localStorage.setItem('usuarioActual', JSON.stringify(usuario));
};

export const limpiarSesion = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('usuarioActual');
  borrarFiltrosGuardados();
};

export const getUsuarioActual = () => {
  try {
    return JSON.parse(localStorage.getItem('usuarioActual') || 'null');
  } catch {
    return null;
  }
};
